export default __webpack_public_path__ + "static/media/9783986100056.adbcec56.webp";